import TerminCreateUpdate from './TerminCreateUpdate';

export default TerminCreateUpdate;
